import md5 from "js-md5"

export const jsonSort = function (jsonData) {
  try {
    let tempJsonObj = {};
    let sdic = Object.keys(jsonData).sort();
    sdic.map((item, index) => {
      tempJsonObj[item] = jsonData[sdic[index]]
    })
    // console.log('将box返回的数据进行输出', tempJsonObj);
    return tempJsonObj;
  } catch (e) {
    return jsonData;
  }
}

export const makeSign = function (data, sign) {
  let get = jsonSort(data);
  delete (get.sign);
  let params = Object.keys(get).map(function (key) {
    if(get[key] instanceof Array){
      get[key] = JSON.stringify(get[key])
    }

    return key + "=" + get[key] + "&";
  }).join("");
  const result = params + sign;
  // console.log("makesign-box-sign", result)
  return md5(result);
}
